/* Deep mega menu: wrap-safe hover (patches theme's HeaderMenu), pane swap, toggles */
(function () {
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---- 1) Hover intent: a menu opens only for a deliberate, settled pointer ----
     The theme's HeaderMenu.onMouseEnter meant to wait 100 ms, but its guard
     (`typeof x === void 0`) can never be true, so the delay was 0 and every
     pointer that crossed the nav row opened a panel - on the way to the
     breadcrumbs, for instance. The sticky header makes it worse: the menu row
     collapses on scroll-down and re-expands on scroll-up, and browsers fire
     mouseenter when the row lands under a pointer that never moved, so menus
     opened while shoppers were only scrolling back up.

     Rules now:
       - open when the pointer entered the item by moving (not the page moving
         under it), has been inside for INTENT_MS and is nearly still;
       - an entry caused by scrolling or layout stays closed until the pointer
         leaves and comes back, or travels UNBLOCK_PX inside the item;
       - open menus close on page scroll, Escape, and any click outside. */
  var INTENT_MS = 120;        // dwell before a menu may open
  var SETTLE_PX = 8;          // movement per poll that still counts as "resting"
  var POLL_MS = 70;
  var MOVE_FRESH_MS = 80;     // mouseenter this soon after a real move = entered by moving
  var SCROLL_QUIET_MS = 300;  // no opening this soon after a page scroll
  var UNBLOCK_PX = 30;        // travel inside a blocked item that re-allows opening
  var CLOSE_DELAY_MS = 300;   // grace after leaving, so wrapped items and the panel stay reachable

  var pointer = { x: -1, y: -1, movedAt: -1e9 };
  var lastScrollAt = -1e9;
  var now = function () { return performance.now(); };

  /* Real pointer movement only: browsers replay a mouse event at the old
     position after scrolling, which shows up here with a zero delta. */
  document.addEventListener(window.PointerEvent ? 'pointermove' : 'mousemove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
    if (e.clientX === pointer.x && e.clientY === pointer.y) return;
    pointer.x = e.clientX;
    pointer.y = e.clientY;
    pointer.movedAt = now();
  }, true);

  function isOpen(hm) {
    return !!(hm.mainDetailsToggle && hm.mainDetailsToggle.open);
  }

  function openMenu(hm) {
    if (isOpen(hm) || !hm.summary) return;
    /* Coming straight from another open menu: no panel fade (base.css), or the
       page would flash through between the two panels. */
    hm.classList.toggle('rs-menu-swap', menuDetayiAcik());
    hm.closeAnyOpenMegaMenus();
    hm.classList.add('open');
    hm.style.setProperty('--link-end', (Number.parseInt(hm.offsetTop + hm.getBoundingClientRect().height) - 1) + 'px');
    hm.style.setProperty('--header-zindex', '1');
    hm.summary.click();
    loadNeighbours(hm.querySelector('.deep-mega__pane.is-active'));
  }

  function closeMenu(hm) {
    if (!isOpen(hm) || hm.preventHoverClose || !hm.summary) return;
    hm.classList.remove('open');
    hm.style.setProperty('--header-zindex', '0');
    hm.summary.click();
  }

  function stopIntent(hm) {
    if (hm._intentPoll) clearInterval(hm._intentPoll);
    hm._intentPoll = null;
  }

  /* Polls while the pointer rests on an unopened item; opens once it settles. */
  function startIntent(hm) {
    if (hm._intentPoll || isOpen(hm) || hm._blocked) return;
    var px = pointer.x;
    var py = pointer.y;
    hm._intentPoll = setInterval(function () {
      if (isOpen(hm) || hm._blocked || !hm.matches(':hover')) { stopIntent(hm); return; }
      var moved = Math.abs(pointer.x - px) + Math.abs(pointer.y - py);
      px = pointer.x;
      py = pointer.y;
      var t = now();
      if (moved <= SETTLE_PX && t - hm._enteredAt >= INTENT_MS && t - lastScrollAt > SCROLL_QUIET_MS) {
        stopIntent(hm);
        openMenu(hm);
      }
    }, POLL_MS);
  }

  function patchedOnMouseEnter() {
    clearTimeout(this.hoverIntentTimer);
    clearTimeout(this._wrapSafeCloseTimer);
    var t = now();
    var byMove = t - pointer.movedAt <= MOVE_FRESH_MS && t - lastScrollAt > SCROLL_QUIET_MS;
    this._blocked = !byMove;
    this._enteredAt = t;
    this._travel = 0;
    this._tx = pointer.x;
    this._ty = pointer.y;
    if (byMove) startIntent(this);
  }

  /* Movement inside the item: a blocked item (entered by layout) is released
     after enough deliberate travel; otherwise just make sure intent is running. */
  function onInstanceMove(e) {
    var hm = this;
    if (isOpen(hm)) return;
    if (e.clientX === hm._tx && e.clientY === hm._ty) return;
    hm._travel += Math.abs(e.clientX - hm._tx) + Math.abs(e.clientY - hm._ty);
    hm._tx = e.clientX;
    hm._ty = e.clientY;
    if (hm._blocked && hm._travel >= UNBLOCK_PX) {
      hm._blocked = false;
      hm._enteredAt = now();
    }
    if (!hm._blocked) startIntent(hm);
  }

  /* Wrap-safe close: wait, then close only if the pointer is really outside
     the item, its panel and the nav (a wrapped second row used to count as
     "outside" and close the menu the shopper was heading for). */
  function patchedOnMouseLeave() {
    clearTimeout(this.hoverIntentTimer);
    clearTimeout(this._wrapSafeCloseTimer);
    stopIntent(this);
    this._blocked = false;
    var self = this;

    this._wrapSafeCloseTimer = setTimeout(function () {
      if (!isOpen(self) || self.preventHoverClose) return;

      var dropdown = self.summary && self.summary.nextElementSibling;
      var nav = self.closest('.header__inline-menu');
      var stillInside =
        self.matches(':hover') ||
        (dropdown && dropdown.matches(':hover')) ||
        (nav && nav.matches(':hover'));

      if (stillInside) return;
      closeMenu(self);
    }, CLOSE_DELAY_MS);
  }

  function setupInstance(hm) {
    if (hm._deepHoverSetup) return;
    hm._deepHoverSetup = true;
    hm._moveHandler = onInstanceMove.bind(hm);
    hm.addEventListener('mousemove', hm._moveHandler);
    /* Instances whose init() ran before the patch still hold the theme's
       original handlers: swap them for the patched ones. */
    if (hm.mouseEnterHandler) {
      hm.removeEventListener('mouseenter', hm.mouseEnterHandler);
      hm.mouseEnterHandler = patchedOnMouseEnter.bind(hm);
      hm.addEventListener('mouseenter', hm.mouseEnterHandler);
    }
    if (hm.mouseLeaveHandler) {
      hm.removeEventListener('mouseleave', hm.mouseLeaveHandler);
      hm.mouseLeaveHandler = patchedOnMouseLeave.bind(hm);
      hm.addEventListener('mouseleave', hm.mouseLeaveHandler);
    }
  }

  function applyPatch() {
    var HM = customElements.get('header-menu');
    if (!HM) return;
    if (!HM.prototype._wrapSafePatched) {
      HM.prototype._wrapSafePatched = true;
      HM.prototype.onMouseEnter = patchedOnMouseEnter;
      HM.prototype.onMouseLeave = patchedOnMouseLeave;
    }
    document.querySelectorAll('header-menu').forEach(setupInstance);
  }

  /* Same as querying 'header-menu > details[open]', without scanning the whole
     page: this runs on every scroll event. */
  var headerMenuler = document.getElementsByTagName('header-menu');
  function menuDetayiAcik() {
    for (var i = 0; i < headerMenuler.length; i++) {
      for (var c = headerMenuler[i].firstElementChild; c; c = c.nextElementSibling) {
        if (c.tagName === 'DETAILS' && c.open) return true;
      }
    }
    return false;
  }

  /* Close every open menu; `block` keeps them shut while the pointer is still
     inside (after Escape, an outside click or a scroll) until it leaves. */
  function closeAllMenus(block) {
    if (!menuDetayiAcik()) return;
    document.querySelectorAll('header-menu > details[open]').forEach(function (d) {
      var hm = d.closest('header-menu');
      if (!hm || hm.preventHoverClose) return;
      stopIntent(hm);
      if (block) hm._blocked = true;
      closeMenu(hm);
    });
  }

  if (FINE) {
    customElements.whenDefined('header-menu').then(applyPatch);
    document.addEventListener('shopify:section:load', applyPatch);

    window.addEventListener('scroll', function () {
      lastScrollAt = now();
      closeAllMenus(true);
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllMenus(true);
    });

    document.addEventListener('pointerdown', function (e) {
      if (e.target.closest && e.target.closest('header-menu')) return;
      closeAllMenus(true);
    }, true);
  }

  /* Leaving the nav altogether closes what is open (second-row wrap, side exits). */
  function initNavCloser() {
    if (!FINE) return;
    document.querySelectorAll('.header__inline-menu').forEach(function (nav) {
      if (nav.dataset.navCloserInit) return;
      nav.dataset.navCloserInit = 'true';
      nav.addEventListener('mouseleave', function () {
        setTimeout(function () {
          nav.querySelectorAll('header-menu > details[open]').forEach(function (d) {
            var hm = d.closest('header-menu');
            if (!hm || hm.preventHoverClose) return;
            var dropdown = hm.summary && hm.summary.nextElementSibling;
            var inside = hm.matches(':hover') || (dropdown && dropdown.matches(':hover')) || nav.matches(':hover');
            if (!inside) closeMenu(hm);
          });
        }, 250);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavCloser);
  } else {
    initNavCloser();
  }
  document.addEventListener('shopify:section:load', initNavCloser);

  /* ---- Scroll cue: fade + "show more" pill while rows remain below ----
     .has-more on a scroll area drives the CSS; recomputed whenever its
     content or box can change (pane swap, fetched grid, group toggle, resize,
     open) and on the area's own scroll. */
  function updateScrollCue(el) {
    if (!el) return;
    /* A closed menu's panel is laid out at the width of its menu item (Chrome),
       which read as a long list: the pill flashed when the menu opened. */
    var d = el.closest('details');
    var more = (!d || d.open) && el.scrollHeight - el.clientHeight - el.scrollTop > 8;
    el.classList.toggle('has-more', more);
  }
  function updateScrollCues(deep) {
    if (!deep) return;
    updateScrollCue(deep.querySelector('.deep-mega__panes'));
    updateScrollCue(deep.querySelector('.deep-mega__rail'));
  }
  /* Element scroll events do not bubble, but they do pass document in the
     capture phase. */
  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (!el || !el.classList) return;
    if (el.classList.contains('deep-mega__panes') || el.classList.contains('deep-mega__rail')) updateScrollCue(el);
  }, true);

  /* ---- 2) Rail hover -> sağ panel (değişiklik yoksa DOM'a dokunma) ---- */
  function activatePane(el) {
    var menu = el.closest('.deep-mega');
    if (!menu) return;
    var id = el.getAttribute('data-deep-target');
    var pane = document.getElementById(id);
    if (!pane || pane.classList.contains('is-active')) return;

    menu.querySelectorAll('.deep-mega__pane.is-active').forEach(function (p) { p.classList.remove('is-active'); });
    pane.classList.add('is-active');

    menu.querySelectorAll('.deep-mega__rail-item.is-active').forEach(function (li) { li.classList.remove('is-active'); });
    var item = el.closest('.deep-mega__rail-item');
    if (item) item.classList.add('is-active');

    var panes = pane.closest('.deep-mega__panes');
    if (panes) {
      panes.scrollTop = 0;
      updateScrollCue(panes);
    }
  }

  /* ---- 2b) Panel içeriğini talep üzerine yükle (Section Rendering API) ----
     Panel grid'i artık HTML'e gömülü değil; {koleksiyon}?section_id=deep-mega-pane
     adresinden ilk hover/focus'ta çekilir. Başarısız fetch bayrağı temizler ki
     bir sonraki hover yeniden denesin. */
  var paneFetches = {};

  /* A list fetched once stays for this tab's session: later pages show it at
     once and send no request. Category names and links only. Change the prefix
     when the markup of sections/deep-mega-pane.liquid changes. */
  function paneCacheGet(src) {
    try { return sessionStorage.getItem('rs-pane2:' + src); } catch (e) { return null; }
  }
  function paneCacheSet(src, html) {
    try { sessionStorage.setItem('rs-pane2:' + src, html); } catch (e) {}
  }

  function ensurePaneLoaded(pane) {
    if (!pane) return;
    var src = pane.getAttribute('data-deep-pane-src');
    if (!src || pane.dataset.deepLoaded === 'true') return;

    var loading = pane.querySelector('.deep-mega__pane-loading');
    var cached = paneCacheGet(src);
    if (cached !== null) {
      pane.dataset.deepLoaded = 'true';
      if (loading) loading.remove();
      pane.insertAdjacentHTML('beforeend', cached);
      if (pane.classList.contains('is-active')) updateScrollCue(pane.closest('.deep-mega__panes'));
      return;
    }

    /* Skeleton rows only for the pane in view; background loads need none. */
    if (loading && pane.classList.contains('is-active')) {
      if (!loading.firstChild) loading.innerHTML = new Array(13).join('<i></i>');
      loading.hidden = false;
    }
    if (paneFetches[pane.id]) return;

    paneFetches[pane.id] = fetch(src)
      .then(function (res) {
        if (!res.ok) throw new Error('deep-mega pane fetch failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        if (pane.dataset.deepLoaded === 'true') return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-deep-pane-content]');
        pane.dataset.deepLoaded = 'true';
        if (loading) loading.remove();
        if (content) {
          paneCacheSet(src, content.innerHTML);
          while (content.firstChild) pane.appendChild(content.firstChild);
        }
        if (pane.classList.contains('is-active')) updateScrollCue(pane.closest('.deep-mega__panes'));
      })
      .catch(function (err) {
        delete paneFetches[pane.id];
        if (loading) loading.hidden = true;
        console.warn(err);
      });

    return paneFetches[pane.id];
  }

  /* The brands next to the one in view load ahead, so moving along the left
     column shows them at once. Not a whole menu or all menus: each list is a
     server render, and about 100 /collections requests in a short time got a test
     browser a Cloudflare challenge (429) on every category page for 2 minutes. The
     home page used to load all 99 lists on the first mouse move. */
  function loadNeighbours(pane) {
    if (!pane || pane._deepNear) return;
    pane._deepNear = true;
    var next = pane.nextElementSibling;
    [next, next && next.nextElementSibling, pane.previousElementSibling].forEach(function (p) {
      if (p && p.classList.contains('deep-mega__pane') && paneCacheGet(p.getAttribute('data-deep-pane-src')) === null) {
        ensurePaneLoaded(p);
      }
    });
  }

  function paneFor(el) {
    return document.getElementById(el.getAttribute('data-deep-target'));
  }

  /* Menüye ilk yaklaşmada (hover/focus) aktif paneli önden yükle —
     menü açıldığında panel-1 boş görünmesin. */
  function prefetchActivePane(e) {
    var hm = e.target.closest('header-menu');
    if (!hm || hm._deepPrefetched) return;
    var deep = hm.querySelector('.deep-mega');
    if (!deep) return;
    hm._deepPrefetched = true;
    ensurePaneLoaded(deep.querySelector('.deep-mega__pane.is-active'));
  }
  document.addEventListener('mouseover', prefetchActivePane);
  document.addEventListener('focusin', prefetchActivePane);

  document.addEventListener('mouseover', function (e) {
    var el = e.target.closest('.deep-mega [data-deep-target]');
    if (el) {
      activatePane(el);
      ensurePaneLoaded(paneFor(el));
      loadNeighbours(paneFor(el));
    }
  });
  document.addEventListener('focusin', function (e) {
    var el = e.target.closest('.deep-mega [data-deep-target]');
    if (el) {
      activatePane(el);
      ensurePaneLoaded(paneFor(el));
      loadNeighbours(paneFor(el));
    }
  });

  /* ---- 3) Tıklamalar — capture-phase ---- */
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-deep-more]');
    if (more) {
      e.preventDefault();
      e.stopPropagation();
      var area = more.closest('.deep-mega__panes');
      if (area) area.scrollBy({ top: Math.round(area.clientHeight * 0.8), behavior: 'smooth' });
      return;
    }
    var arrow = e.target.closest('.deep-mega__rail-arrow');
    if (arrow) {
      e.preventDefault();
      e.stopPropagation();
      activatePane(arrow);
      ensurePaneLoaded(paneFor(arrow));
      return;
    }
    var btn = e.target.closest('[data-deep-toggle]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var group = btn.closest('.deep-mega__group');
      var list = group && group.querySelector('.deep-mega__group-list');
      if (!list) return;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      list.hidden = isOpen;
      updateScrollCue(btn.closest('.deep-mega__panes'));
    }
  }, true);

  /* ---- 4) Kapanis yollari ----
     Uzun bir menu ekranin altina kadar uzaninca fareyle asagi dogru cikacak
     yer kalmiyordu: panel nav'in hemen altinda basliyor, yukari cikmak da
     nav'in uzerinden gectigi icin menuyu acik tutuyor. Cikis yolu asagida
     her zaman birakilan alt bosluk.

     Escape denendi ve birakildi: bu temada panel details[open] durumuna degil
     hover'a bagli, dolayisiyla kapatacak bir durum yok - fare hala panelin
     uzerindeyken kapatilsa aninda yeniden acilirdi. */
  /* Panelin yuksekligi 60vh sabitiydi; bu, panelin ekranda nerede basladigini
     hesaba katmadigi icin kisa pencerelerde panel alt kenardan tasiyordu
     (700px'lik gorunum alaninda 25px disari). Kalan yeri panelin gercek ust
     konumundan olcup altta sabit bir bosluk birakiyoruz - fare oradan cikip
     menuyu kapatabilsin. Sticky header'da ust konum degistigi icin acilista,
     yeniden boyutlamada ve kaydirmada tazeleniyor. */
  /* Pay, .deep-mega'nin ust dolgusundan (20px) ve panelin alt dolgusundan
     (4px, base.css .mega-menu__content--deep) olculur: 72 verince panelin
     altinda ~48px cikis boslugu kalir. */
  var KACIS_BOSLUGU = 72;
  function boyutla(deep) {
    if (!deep) return;
    var ust = deep.getBoundingClientRect().top;
    var yer = window.innerHeight - ust - KACIS_BOSLUGU;
    deep.style.setProperty('--deep-mega-max', Math.max(220, Math.round(yer)) + 'px');
    updateScrollCues(deep);
  }
  /* Panelin gorunur olup olmadigini details[open] uzerinden okumak yanilticiydi:
     bu tema paneli baska bir mekanizmayla gosteriyor ve olcum sirasinda
     nitelik yerinde olmuyor. Olculen sey dogrudan gorunurluk. */
  /* Olcum yalnizca bir menu acikken (ya da fare menu cubugundayken) yapilir ve
     ayni karedeki olaylar tek olcumde birlesir. Eskiden menuler kapaliyken de her
     kaydirmada, her toggle'da ve menu cubugundaki her fare hareketinde
     getBoundingClientRect cagriliyordu; bu, tum sayfanin duzenini zorla yeniden
     hesaplatiyordu (PageSpeed: forced reflow). Secici kontrolu duzen
     hesaplatmaz. */
  var boyutlaBekliyor = false;
  function menuAcikOlabilir() {
    if (menuDetayiAcik()) return true;
    for (var i = 0; i < headerMenuler.length; i++) {
      if (headerMenuler[i].classList.contains('open') || headerMenuler[i].matches(':hover')) return true;
    }
    return false;
  }
  function acikPanelleriBoyutla() {
    if (boyutlaBekliyor || !menuAcikOlabilir()) return;
    boyutlaBekliyor = true;
    requestAnimationFrame(function () {
      boyutlaBekliyor = false;
      document.querySelectorAll('.deep-mega').forEach(function (deep) {
        if (deep.getBoundingClientRect().height > 0) boyutla(deep);
      });
    });
  }
  document.addEventListener('toggle', function () { acikPanelleriBoyutla(); }, true);
  document.addEventListener('mouseover', function (e) {
    if (e.target.closest && e.target.closest('.header__inline-menu')) acikPanelleriBoyutla();
  });
  window.addEventListener('resize', acikPanelleriBoyutla);
  window.addEventListener('scroll', acikPanelleriBoyutla, { passive: true });

})();